import React from 'react'
import { View, Text } from '@react-pdf/renderer'
import { themeConfig } from '../../config/theme.config'
import SectionTitle from './SectionTitle'

const ScoresDescriptionContent = () => {
  return (
    <View
      style={{
        display: 'flex',
        gap: 20,

        fontFamily: 'Roboto'
      }}
    >
      <View
        style={{
          width: '40%',
          display: 'flex'
        }}
      >
        <SectionTitle sectionTitle="Average Score" />
        <Text
          style={{
            fontSize: 10,
            // color: themeConfig.semcogLightGray,
            fontFamily: 'Roboto',
            lineHeight: 1.5
          }}
        >
          Each street user’s average score of all their elements determines
          their overall score.
        </Text>
      </View>
      <View
        style={{
          width: '40%',

          display: 'flex'
        }}
      >
        <SectionTitle sectionTitle="Weakest Link Score" />
        <Text
          style={{
            fontSize: 10,
            fontFamily: 'Roboto',
            lineHeight: 1.5
          }}
        >
          Each street user’s lowest-scoring element determines their overall
          score.
        </Text>
      </View>
    </View>
  )
}

export default ScoresDescriptionContent
